import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { setLocalVars } from './redux/FlowReducer';
import { toast } from 'react-toastify';

const LocalVarsDialog = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const localVars = useSelector((s) => s.flow.localVars || []);
  const [vars, setVars] = useState([]);
  const [name, setName] = useState('');
  const [type, setType] = useState('Integer');
  const [sel, setSel] = useState(-1);
  const types = ['Integer', 'Float', 'String', 'Boolean', 'DateTime'];

  useEffect(() => { if (open) setVars(localVars); }, [open, localVars]);

  const handleClose = useCallback(() => { setVars([]); setName(''); setType('Integer'); setSel(-1); onClose(); }, [onClose]);
  const handleSave = useCallback(() => { dispatch(setLocalVars(vars)); toast.success('Değişkenler kaydedildi'); handleClose(); }, [vars, dispatch, handleClose]);
  const addVar = () => {
    if (!name.trim()) { toast.warning('İsim boş olamaz'); return; }
    if (vars.some(v => v.name === name)) { toast.warning('Bu isimde değişken var'); return; }
    setVars(prev => [...prev, { name, type }]); setName(''); setType('Integer');
  };
  const delVar = () => { if (sel !== -1) { setVars(prev => prev.filter((_, i) => i !== sel)); setSel(-1); toast.info('Silindi'); } };

  if (!open) return null;
  return (
    <>
      <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', zIndex: 1000 }} onClick={handleClose} />
      <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', width: 600, maxWidth: '90%', maxHeight: '90%', overflowY: 'auto', padding: 24, background: '#f8f4ff', border: '1px solid #e0d0ff', borderRadius: 8, zIndex: 1001 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h2 style={{ margin: 0 }}>Yerel Değişkenler</h2>
          <IconButton onClick={handleClose} size="small"><CloseIcon /></IconButton>
        </div>
        <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Değişken adı" style={{ flex: 2, padding: 8, border: '1px solid #d3d3d3', borderRadius: 4 }} />
          <select value={type} onChange={(e) => setType(e.target.value)} style={{ flex: 1, padding: 8, border: '1px solid #d3d3d3', borderRadius: 4 }}>
            {types.map(t => <option key={t} value={t}>{t}</option>)}
          </select>
          <button onClick={addVar} style={{ padding: '8px 16px' }}>Ekle</button>
        </div>
        <div style={{ border: '1px solid #d3d3d3', borderRadius: 4, background: '#fff', maxHeight: 300, overflowY: 'auto', marginBottom: 12 }}>
          <div style={{ display: 'flex', fontWeight: 600, padding: '8px 10px' }}>
            <div style={{ flex: 2 }}>Ad</div>
            <div style={{ flex: 1 }}>Tip</div>
          </div>
          {vars.map((v, i) => (
            <div key={i} onClick={() => setSel(i)} style={{ display: 'flex', padding: '8px 10px', background: sel === i ? '#e0d0ff' : 'transparent', cursor: 'pointer', borderTop: '1px solid #f0e6ff' }}>
              <div style={{ flex: 2 }}>{v.name}</div>
              <div style={{ flex: 1 }}>{v.type}</div>
            </div>
          ))}
          {vars.length === 0 && <div style={{ padding: 16, textAlign: 'center', color: '#666', fontStyle: 'italic' }}>Henüz değişken yok.</div>}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <button onClick={delVar} disabled={sel === -1} style={{ padding: '8px 16px' }}>Sil</button>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={handleClose} style={{ padding: '8px 16px' }}>İptal</button>
            <button onClick={handleSave} style={{ padding: '8px 16px' }}>Kaydet</button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LocalVarsDialog;

